import React from "react";
import { Button } from "react-bootstrap";

const ResetFilterButton = ({ table, onReset }) => {
  if (
    !table.getState().columnFilters.length &&
    !table.getState().globalFilter
  ) {
    return null; // Don't render the button if there are no active filters
  }
  return (
    <Button
      variant="outline-secondary"
      size="sm"
      onClick={() => {
        table.resetColumnFilters();
        table.setGlobalFilter("");
        if (onReset) onReset();
      }}
    >
      Ponastavi filtre
    </Button>
  );
};

export default ResetFilterButton;
